var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 81,
    viewBox: "0 0 216 81",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.106 74c1.73-.964 3.044-2.129 3.942-3.493 2.08-3.16 2.054-10.027 1.879-15.764 1.54.151 3.223.237 5.05.257 6.526-.01 11.244-.88 14.155-2.607-.028.2-.042.403-.042.607 0 2.577 2.587 4.91 7.76 7 5 0 9.054 3.134 9.054 7s-4.053 7-9.054 7h-32.744Zm-38.89 0H59.498c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7H9.054C4.054 60 0 56.866 0 53s4.054-7 9.054-7H60.79c1.989 0 3.828-.496 5.322-1.336.168 2.22.563 4.22 1.41 5.458 2.163 3.156 7.648 4.782 16.455 4.878a58.31 58.31 0 0 0 5.06-.211c-.125 5.736-.05 12.516 2.12 15.718.925 1.364 2.278 2.528 4.06 3.493ZM66.17 33.37c-1.504-.861-3.365-1.37-5.38-1.37H28.455c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7h51.737c-5 0-9.054-3.134-9.054-7 0-3.146 2.685-5.808 6.38-6.69A8 8 0 1 0 90.245 4h15.998A11.24 11.24 0 0 0 103 11.901c0 6.27 5.149 11.353 11.5 11.353S126 18.17 126 11.9A11.24 11.24 0 0 0 122.757 4h15.998a8 8 0 1 0 12.49 0h55.701c5 0 9.054 3.134 9.054 7s-4.054 7-9.054 7H155.21c5 0 9.053 3.134 9.053 7 0 1.676-.761 3.214-2.032 4.42C160.96 23.484 157.7 18 152.594 18c-3.124 0-5.008 2.582-7.733 2.582-2.831 0-4.778-2.582-7.771-2.445-3.747.172-6.452 3.198-8.091 7.137a9.488 9.488 0 0 0-3.74-.759c-4.426 0-7.096 3.697-10.956 3.697-4.01 0-6.768-3.697-11.01-3.5a9.805 9.805 0 0 0-3.265.716C98.348 21.237 95.516 18 91.594 18c-3.124 0-5.008 2.582-7.733 2.582-2.831 0-4.778-2.582-7.771-2.445-6.12.28-9.46 8.178-9.92 15.232ZM162.657 32h21.008c5 0 9.054 3.134 9.054 7s-4.054 7-9.054 7h-13.16c-3.135 0-5.975.775-8.038 2.03.919-3.734.37-9.71.37-12.999 0-.985-.06-2.004-.18-3.031Zm44.29 14c-5.001 0-9.055-3.134-9.055-7s4.054-7 9.054-7S216 35.134 216 39s-4.054 7-9.054 7Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.109 25.083c-1.67-4.29-4.53-7.632-8.515-7.632-3.124 0-5.008 2.582-7.733 2.582-2.831 0-4.778-2.582-7.771-2.445-6.607.302-9.974 9.481-9.974 16.894 0 4.11-.715 11.995 1.407 15.09 2.162 3.156 7.647 4.782 16.454 4.879 2.454-.054 4.217-.131 5.288-.232",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    cx: 85,
    cy: 8.451,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.202 54.22c.977.09 2.568.167 4.775.23 8.943-.014 14.492-1.64 16.645-4.878 2.033-3.056 1.216-11.075 1.216-15.09 0-7.525-3.523-17.031-10.244-17.031-3.124 0-5.008 2.582-7.733 2.582-2.831 0-4.778-2.582-7.771-2.445-3.774.173-6.491 3.242-8.127 7.224",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    cx: 146,
    cy: 8.451,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.467 76.943c12.67-.021 20.53-2.35 23.581-6.985 2.88-4.375 1.722-15.858 1.722-21.607 0-10.774-4.99-24.385-14.511-24.385-4.426 0-7.096 3.697-10.956 3.697-4.01 0-6.768-3.697-11.01-3.5-9.359.432-14.13 13.575-14.13 24.188 0 5.886-1.011 17.174 1.994 21.607 3.064 4.519 10.834 6.847 23.31 6.985Z",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    cx: 115.5,
    cy: 11.352,
    rx: 11.5,
    ry: 11.352
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.c8c70e2de0b8bd49c6b14876a3172817.svg";
export { ForwardRef as ReactComponent };